import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { ISuccessLoginResponse } from '@shared/interfaces/successLoginResponse.interface';

@Injectable({
  providedIn: 'root'
})
export class AuthConnectionService {

  private isLoggedIn = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) { }

  login(credentials: { employee_code: number; password: string; remember: boolean; is_app: boolean }) {
    return this.http.post<ISuccessLoginResponse>(`${environment.baseUrl}/login`, credentials);
  }

  recovery(userData: any) {
    return this.http.post(`${environment.baseUrl}/register`, userData);
  }

  logout(): Observable<any> {
    return this.http.get(`${environment.baseUrl}/logout`, {}).pipe(
      tap(() => {
        localStorage.removeItem('access_token');
        localStorage.removeItem('me');
      })
    );
  }
}






